import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { TableCard } from "@/components/ui/table-card";
import { UserRow } from "./UserRow";
import { useCategories } from "@/hooks/useCategories";
import type { User } from "@/types";

interface UserTableProps {
  users: User[];
}

export function UserTable({ users }: UserTableProps) {
  const { data: categories = [] } = useCategories();

  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Email</TableHead>
            <TableHead>Rola</TableHead>
            <TableHead>Powiadomienia</TableHead>
            <TableHead>Wersje prawne</TableHead>
            <TableHead>Data rejestracji</TableHead>
            <TableHead />
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <UserRow key={user.id} user={user} categories={categories} />
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
